// prettier-ignore

// Used for progress bars
const PETITION_TIERS = [
  5,
  10,
  25,
  50,
  100,
  250,
  500,
  1000,
  2000,
  3000,
  5000,
  10000,
  25000,
  50000,
  75000,
  100000,
  250000,
  750000,
  1000000,
  1250000,
  1500000,
  1750000,
  2000000,
  2250000,
  2500000,
  2750000,
  3000000,
  3250000,
  3500000,
  3750000,
  4000000,
  4250000,
  4500000,
  4750000,
  5000000,
  5250000,
  5500000,
  5750000,
  6000000,
  6250000,
  6500000,
  6750000,
];

export { PETITION_TIERS };
